import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Download } from "react-feather";
import { Spinner } from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AllApprovedListing = () => {
  const [listings, setListings] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch approved listings
  useEffect(() => {
    const fetchApprovedListings = async () => {
      try {
        const response = await axios.get(`${baseurl}getApprovedSellerListings`);
        if (response.data.success) {
          setListings(response.data.data);
          setFilteredData(response.data.data);
        }
      } catch (error) {
        console.error("❌ Error fetching listings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchApprovedListings();
  }, []);

  // Excel Download
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Approved Seller Listings");
    XLSX.writeFile(wb, "approved_seller_listings.xlsx");
  };

  // Handle Sale Tag Change
  const handleSaleTagChange = (row, selectedType) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Set "${selectedType}" as Sale Type?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const payload = { listing_id: row.id, sale_type: selectedType };
          const response = await axios.post(`${baseurl}updateSaleTag`, payload);

          if (response.data.success) {
            Swal.fire("Updated!", "Sale type updated successfully.", "success");
            setListings((prev) =>
              prev.map((listing) =>
                listing.id === row.id ? { ...listing, sale_type: selectedType } : listing
              )
            );
            setFilteredData((prev) =>
              prev.map((listing) =>
                listing.id === row.id ? { ...listing, sale_type: selectedType } : listing
              )
            );
          } else {
            Swal.fire("Error", "Failed to update sale type.", "error");
          }
        } catch (error) {
          console.error("❌ Error updating sale type:", error);
          Swal.fire("Error", "Something went wrong.", "error");
        }
      }
    });
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4>Approved Seller Listings</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search Listings"
                onChange={(e) =>
                  setFilteredData(
                    listings.filter((listing) =>
                      listing.title
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                    )
                  )
                }
              />
              <span className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} /> &nbsp;Download
              </span>
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              {loading ? (
                <div className="p-3">
                  {/* Skeleton for table header */}
                  <Skeleton height={35} count={1} style={{ marginBottom: "10px" }} />

                  {/* Skeleton rows */}
                  <table className="custom-table w-100">
                    <thead>
                      <tr>
                        {Array(7)
                          .fill()
                          .map((_, i) => (
                            <th key={i}>
                              <Skeleton height={20} />
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Array(6)
                        .fill()
                        .map((_, i) => (
                          <tr key={i}>
                            {Array(7)
                              .fill()
                              .map((__, j) => (
                                <td key={j}>
                                  <Skeleton height={20} />
                                </td>
                              ))}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div style={{ overflowX: "auto", maxHeight: "500px" }}>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>UniqueID</th>
                        <th>Condition</th>
                        <th>Created At</th>
                        <th>Actions</th>
                        <th>Sale Tag</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((row, index) => (
                        <tr key={index}>
                          <td>{row.id}</td>
                          <td
                            style={{
                              maxWidth: "200px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {row.title}
                          </td>
                          <td>{row.qkid}</td>
                          <td>{row.condition}</td>
                          <td>{new Date(row.created_at).toLocaleDateString()}</td>
                          <td>
                            <Link
                              to={`/admin/seller-listing-details/${row.id}`}
                              className="btn btn-primary btn-sm"
                            >
                              View Details
                            </Link>
                          </td>
                          <td>
                            <select
                              className="form-select"
                              value={row.sale_type || ""}
                              onChange={(e) =>
                                handleSaleTagChange(row, e.target.value)
                              }
                            >
                              <option value="">Select Type</option>
                              <option value="Best Selling">Best Selling</option>
                              <option value="Hot Sales">Hot Sales</option>
                              <option value="Normal Sale">Normal Sale</option>
                              <option value="Featured Product">
                                Featured Product
                              </option>
                            </select>
                          </td>
                        </tr>
                      ))}
                      {filteredData.length === 0 && (
                        <tr>
                          <td colSpan="7" className="text-center py-3">
                            No listings found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllApprovedListing;
